'use client'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark, faTableCells, faArrowRight } from '@fortawesome/pro-solid-svg-icons'
import {
  Button,
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from '@teqplay/ui'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import Link from 'next/link'

import { useAnalytics } from '@/app/lib/analytics'

import './ModalESOF.scss'

export type TPropsModalESOF = {
  isOpen: boolean
  onClose: () => void
}

const ModalESOF = ({ isOpen, onClose }: TPropsModalESOF) => {
  const t = useTranslations('VesselAlertCTA.esofCTA.modal')
  const { trackTeqplayRedirectCTA } = useAnalytics()

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent aria-describedby="esof-modal-description" className="dialog-esof">
        <DialogClose asChild>
          <Button variant="neutral-tertiary" className="dialog-close-btn">
            <FontAwesomeIcon icon={faXmark} />
          </Button>
        </DialogClose>

        <DialogHeader className="dialog-esof-header">
          <DialogTitle asChild>
            <h2>
              <FontAwesomeIcon icon={faTableCells} />
              {t('title')}
            </h2>
          </DialogTitle>
        </DialogHeader>

        <div id="esof-modal-description" className="dialog-esof-content">
          <img
            src="https://teqplay.com/wp-content/uploads/2025/07/esof-e1770638949838.png"
            alt={t('title')}
            width={600}
            height={400}
            className="dialog-esof-image"
          />
          <p className="dialog-esof-message">{t('message')}</p>
        </div>

        <DialogFooter className="dialog-esof-footer">
          <Link
            href="https://teqplay.com/smarter-operations/port-reporter/"
            className="button brand-primary"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() =>
              trackTeqplayRedirectCTA({
                source: 'esof_modal',
                url: 'https://teqplay.com/smarter-operations/port-reporter/'
              })
            }
          >
            {t('button')}
            <FontAwesomeIcon icon={faArrowRight} />
          </Link>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default ModalESOF
